"use client";

import { useNavigate } from "react-router-dom";
import { FileText } from "lucide-react";
import { ROUTES } from "@/config/routes";

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg flex items-center justify-center">
                <FileText className="h-5 w-5 text-white" />
              </div>
              <span className="text-xl font-bold">FitMyResume</span>
            </div>
            <p className="text-gray-400 mb-4">
              Create Job Tailored Resumes Instantly and Land Your Dream Job
            </p>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Support</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <button
                  onClick={() => navigate(ROUTES.ABOUT)}
                  className="hover:text-white transition-colors"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate(ROUTES.CONTACT)}
                  className="hover:text-white transition-colors"
                >
                  Contact Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate(ROUTES.PRIVACY_POLICY)}
                  className="hover:text-white transition-colors"
                >
                  Privacy Policy
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate(ROUTES.TERMS_OF_USE)}
                  className="hover:text-white transition-colors"
                >
                  Terms & Conditions
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate(ROUTES.CANCELLATIONS_REFUNDS)}
                  className="hover:text-white transition-colors"
                >
                  Cancellations & Refunds
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Resources</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <button
                  onClick={() => navigate(ROUTES.PRICING)}
                  className="hover:text-white transition-colors"
                >
                  Pricing
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate(ROUTES.TEMPLATES)}
                  className="hover:text-white transition-colors"
                >
                  Resume Templates
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} FitMyResume. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
